import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

export const FretMarkerLabelsSelector: React.FC = () => {
  const showFretMarkerLabels = useFretboardConfigStore((state) => state.showFretMarkerLabels);
  const setShowFretMarkerLabels = useFretboardConfigStore((state) => state.setShowFretMarkerLabels);

  const handleChange = () => {
    setShowFretMarkerLabels(!showFretMarkerLabels);
  };

  return (
    <div className="form-control w-full mb-3 max-w-full">
      <label className="label">
        <span className="label-text">Fret Marker Labels</span>
      </label>
      <div className="flex items-center justify-between">
        <span className="text-sm opacity-70">{showFretMarkerLabels ? 'Visible' : 'Hidden'}</span>
        <input
          type="checkbox"
          className="toggle toggle-primary"
          checked={showFretMarkerLabels}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
